
import {throwError as observableThrowError,  Observable, of, from } from 'rxjs';
/*
 * Wmb, Worldline Merchant Billing.
 * Copyright (C) 2017-2019 Worldline
 * All Rights Reserved
 * This product is protected by copyright. Any copying or distribution
 * is forbidden without the agreement of Worldline.
 */
import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { switchMap, tap } from 'rxjs/operators';

import { environment } from '../environments/environment';

import { KeycloakService } from 'security/keycloak.service';
import { Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { ConfigurationService } from 'app/core/services/configuration.service';

@Injectable()
export class AuthentificationInterceptor implements HttpInterceptor {

    constructor(
        private keycloakService: KeycloakService,
        private router: Router,
        private configService: ConfigurationService,
        private log: NGXLogger
    ) {
        this.log.info('[KeyCloak] interceptor created !');
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // le service est il active et operationnel ?
        if (this.keycloakService.isKeyCloakActive()) {
            // la ressource demande necessite t elle une authentification ?
            if (this.mustAddAuthentificationToken(req)) {

                return from(this.keycloakService.waitForInitializationEnd())
                    .pipe(switchMap((ended, index): Observable<string> => {
                        if (ended) { // initilisation terminee avec success ...
                            if (this.keycloakService.isLoggedIn()) { // authentifie ...
                                // refresh token and call ws services ...
                                this.log.debug('[KeyCloak] Logged in ! Refresh Access Token ...');
                                return from(this.keycloakService.getToken());
                            } else {
                                this.log.debug('not logged in :p :p')
                                return of('NOTLOGGEDIN');
                            }
                        } else {
                            return observableThrowError('[KeyClaok] Bad initialisation !');
                        }
                    }))
                    .pipe(tap((token) => { }, (err) => {
                        // we have an error while refreshing token

                        if (this.configService.config.security.errorRefreshTokenRedirectToURI === undefined) {
                            this.log.log('[KeyCloak] Error while refreshing token ! Do nothing !');
                        } else if (this.configService.config.security.errorRefreshTokenRedirectToURI === 'LOGIN') {
                            this.log.log('[KeyCloak] Error while refreshing token ! send a login request !');
                            this.keycloakService.login()
                            .subscribe(loggedIn => {
                                if (loggedIn) {
                                    this.log.log('logged IN ! Success !');
                                } else {
                                    this.log.log('Not logged in - Login failed !');
                                }
                            })
                            ;
                        } else {
                            this.log.log('[KeyCloak] Error while refreshing token ! redirect to ',
                                this.configService.config.security.errorRefreshTokenRedirectToURI);
                            this.router.navigate([this.configService.config.security.errorRefreshTokenRedirectToURI]);
                        }
                    }))
                    .pipe(switchMap((value, index): Observable<HttpEvent<any>> => {
                        switch (value) {
                            case 'NOTLOGGEDIN':
                                this.log.debug('[KeyCloak] Not authenticated ! Call without authentification headers ...');
                                return next.handle(req);

                            default:
                                this.log.debug('[KeyCloak] Access Token OK, sending new request ...');
                                const newRequest: HttpRequest<any> = req.clone({
                                    setHeaders: {
                                        'Authorization': 'Bearer ' + value
                                    }
                                });
                                return next.handle(newRequest);
                        }
                    }));
            } else {
                this.log.debug('[KeyCloak] Call without authentification headers because it isn\'t required ...');
                return next.handle(req);
            }
        } else {
            this.log.debug('[KeyCloak] not active  ... sending request without change ...');
            return next.handle(req);
        }
    }

    // return true i fwe must add authentification token to headers before call the service
    private mustAddAuthentificationToken(req: HttpRequest<any>): boolean {
        const url: string = req.url;
        const regexArrays: string[] = this.configService.config.security.noSecurityTokenFor;
        for (const expr of regexArrays) {
            const rg: RegExp = new RegExp(expr);
            if (rg.test(url)) {
                this.log.debug('[KeyCloak] Token usage Exclusion found ! url = ' + url + ' - regEx = ' + expr);
                return false;
            }
        }
        return true;
    }
}
